<template>
  <div>
    <d-card>
      <d-card-row v-if="property">
        <v-property-pictures
          :property="property"
          :media="property.media"
          mode="create"
          @delete="fetch"
          @upload="fetch"
        />

        <div class="is-flex">
          <button type="button" class="button is-default mr-3" @click="reset">
            {{ $t("previous").capitalize() }}
          </button>
          <router-link
            class="button is-primary"
            :to="`/properties/create/${property.id}/status`"
          >
            {{ $t("next") }}
          </router-link>
        </div>
      </d-card-row>
    </d-card>
  </div>
</template>

<script>
import propertyPictures from "./components/propertyPictures.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("pictures"),
    };
  },
  components: {
    "v-property-pictures": propertyPictures,
  },
  data() {
    return {
      property: null,
    };
  },
  created() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.$http
        .get(
          this.$laravel.route("api.properties.show", {
            property: this.$route.params.property,
          })
        )
        .then((response) => {
          this.loading = false;
          this.property = response.data.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    reset() {
      this.$router.push({
        name: "properties.create",
        query: { reset: true, id: this.property.id },
      });
    },
  },
};
</script>
